<div class="fancy-hero-one">
    <div class="container">
      <div class="row">
        <div class="col-xl-9 col-lg-11 m-auto">
          <!-- <div class="page-title">Contact us</div> -->
          <h2 class="font-rubik">Register Asset</h2>
        </div>
      </div>
    </div>
  </div>
  
  <div class="hero-banner-one contact-us-light">
    <div class="hero-upper-container">
        <div class="container d-flex align-items-center justify-content-center">
          <form ngNativeValidate #subForm="ngForm" (submit)="submitProperty(subForm.value)">
            <div class="form-style-light">
              <div class="row controls">
                <div class="col-md-6">
                  <div class="input-group-meta form-group mb-25 disabled_input">
                    <label>Name</label>
                    <input disabled  type="text" placeholder="Enter Name" name="name" ngModel [(ngModel)]="name">
                  </div>
                </div>
                
                <div class="col-md-6">
                  <div class="input-group-meta form-group mb-25 disabled_input">
                    <label>Email</label>
                    <input disabled  type="email" placeholder="Enter Email" name="email" ngModel [(ngModel)]="email">
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="input-group-meta form-group mb-25 disabled_input">
                    <label>Mobile Number</label>
                    <input disabled  type="number" placeholder="Enter Mobile Number" name="mobile_no" ngModel [(ngModel)]="mobile_no">
                  </div>
                </div>
  
                
                
              </div>
              <!-- <div class="row controls">     
                <div class="col-md-12">
                  <div class="input-group-meta form-group mb-25">
                    <label>Address*</label>
                    <input  type="text"  placeholder="Enter Address"
                    name="address" [(ngModel)]="address">
                  </div>
                </div>
              </div> -->

              <h4>Add Asset Details</h4>

              <div class="row controls">  
                <div  class="col-md-6">
                    <div class="input-group-meta form-group mb-25">
                      <label>Asset Use Type*</label>
                      <select required [ngModelOptions]="{standalone: true}" #property_use_type="ngModel" name="property_use_type" ngModel [(ngModel)]="property_use_type_id" 
                      (change)="getPropertyTypesList()">
                        <option value="">Select</option>
                        <option *ngFor="let option of prop_use_type_data" [ngValue]="option.id">{{option?.name}}</option>
                      </select>        
                      <div class="error_text"  *ngIf="property_use_type.touched">
                        <p *ngIf="property_use_type.errors?.['required']">Asset Use Type is required.</p>
                      </div>     
                    </div>
                </div>
                    <div  class="col-md-6">
                        <div class="input-group-meta form-group mb-25">
                          <label>Asset Type*</label>
                          <select required [ngModelOptions]="{standalone: true}"  #property_type="ngModel" name="property_type" ngModel [(ngModel)]="property_type_id">
                            <option value="">Select</option>
                            <option *ngFor="let option of prop_type_data" [ngValue]="option.id">{{option?.type_name}}</option>
                          </select>
                      <div class="error_text"  *ngIf="property_type.touched">
                        <p *ngIf="property_type.errors?.['required']">Asset Type is required.</p>
                      </div>           
                        </div>
                    </div>
                  </div>
                  <div class="row controls">  
                    <div *ngIf="is_commercial" class="col-md-6">
                      <div class="form-group mb-25">
                          <!-- <label>Select</label> -->
                          <ul class="sel_radio">
                            <li>
                              <input  type="radio" name="tax_number_type" value="PAN" ngModel [(ngModel)]="tax_number_type">
                              <span>PAN</span>
                            </li>
                            <li>
                              <input  type="radio" name="tax_number_type" value="GST" ngModel [(ngModel)]="tax_number_type">
                              <span>GST</span>
                            </li>
                          </ul>
                      </div>
                  </div>

                    <div *ngIf="is_commercial" class="col-md-6">
                        <div class="input-group-meta form-group mb-25">
                            <label  *ngIf="tax_number_type == 'GST'">GST Number*</label>
                            <label  *ngIf="tax_number_type == 'PAN'">PAN Number*</label>
                            <ng-constainer *ngIf="tax_number_type == 'GST'">
                            <input type="text" name="tax_number" placeholder="Enter GST Number" ngModel
                               #tax_number="ngModel" pattern="\d{2}[A-Z]{5}\d{4}[A-Z]{1}[A-Z\d]{1}[Z]{1}[A-Z\d]{1}" required>
                            <div class="error_text" *ngIf="tax_number.touched">
                              <p *ngIf="tax_number.errors?.['required']">GST is required.</p>
                              <p *ngIf="tax_number.errors?.['pattern']">Please enter valid GST Number</p>
                            </div>
                          </ng-constainer>
                          <ng-constainer *ngIf="tax_number_type == 'PAN'">
                            <input  type="text"  
                            placeholder="Enter PAN Number" name="tax_number" ngModel  #tax_number="ngModel" pattern="[A-Z]{5}[0-9]{4}[A-Z]{1}" required>
                            <div class="error_text"  *ngIf="tax_number.touched">
                              <p *ngIf="tax_number.errors?.['required']">PAN is required.</p>
                              <p *ngIf="tax_number.errors?.['pattern']">Please enter valid PAN Number</p>
                            </div>
                          </ng-constainer>
                        </div>
                    </div>

              </div>

              <div class="row controls">  
                <div class="col-md-6">
                  <div class="input-group-meta form-group mb-25">
                      <label>Zip Code*</label>
                      <input required type="number" placeholder="Enter Zip Code" name="property_zip_code" ngModel 
                      #property_zip_code="ngModel"  pattern="[1-9]{1}[0-9]{5}">
                      <div class="error_text"  *ngIf="property_zip_code.touched">
                        <p *ngIf="property_zip_code.errors?.['required']">Zip Code is required.</p>
                        <p *ngIf="property_zip_code.errors?.['pattern']">Please enter valid Zip Code</p>
                      </div>
                  </div>
                  </div>
                </div>
              <div class="row controls">     
                <div class="col-md-6">
                    <div class="form-group mb-25">
                            <ul class="sel_radio">
                              <li>
                                <input required checked type="radio"  #property_area="ngModel" ngModel name="total_dimention" value="1" [(ngModel)]="area_type">
                                <span>Area</span>
                              </li>
                              <li>
                                <input type="radio"  #property_area="ngModel" ngModel name="total_dimention" value="2" [(ngModel)]="area_type">
                                <span>Dimensions</span>
                              </li>
                            </ul>
                            <div class="error_text"  *ngIf="property_area.touched">
                              <p *ngIf="property_area.errors?.['required']">Area is required.</p>
                            </div>
                        </div>
                    </div>

                <div *ngIf="area_type == '1'" class="col-md-6">
                  <div  class="input-group-meta form-group mb-25">
                      <label>Area*</label>
                      <input required #property_area="ngModel" type="number" placeholder="sq. ft." name="property_area" ngModel>
                      <div class="error_text"  *ngIf="property_area.touched">
                        <p *ngIf="property_area.errors?.['required']">Area is required.</p>
                      </div>
                  </div>
                  </div>

                  <div *ngIf="area_type == '2'" class="col-md-3">
                    <div class="input-group-meta form-group mb-25">
                        <label>Width*</label>
                        <input  type="number" placeholder="In ft." 
                        [(ngModel)]="property_area_width" (keyup)="getTotalArea(subForm.value)" [ngModelOptions]="{standalone: true}">
                        <!-- <div class="error_text"  *ngIf="property_area_width.touched">
                          <p *ngIf="property_area_width.errors?.['required']">Property Area Width is required.</p>
                        </div> -->
                    </div>
                    </div>

                    <div *ngIf="area_type == '2'" class="col-md-3">
                      <div class="input-group-meta form-group mb-25">
                          <label>Length*</label>
                          <input  type="number" placeholder="In ft."
                          [(ngModel)]="property_area_length" (keyup)="getTotalArea(subForm.value)" [ngModelOptions]="{standalone: true}">
                          <!-- <div class="error_text"  *ngIf="property_area_length.touched">
                            <p *ngIf="property_area_length.errors?.['required']">Property Area Height is required.</p>
                          </div> -->
                      </div>
                      </div>
                </div>

                <div class="row controls">  

                  <ng-container *ngFor="let model of modelData['regionHierarchyUlb']; let i = index">
                    <div class="col-md-6">
                      <div class="input-group-meta form-group mb-25"> 
                    <label>{{model?.field_label}}*</label>
                      <select required [ngModelOptions]="{standalone: true}"  #region_name="ngModel" name="region_name" (ngModelChange)="modelChange($event, model, 'regionHierarchyUlb', i, 2)" name="region_id" ngModel [(ngModel)]="modelData['regionHierarchyUlb'][i].ngmodel">
                        <option value="">Select</option>
                        <option *ngFor="let option of model.field_data" [ngValue]="option">{{option?.label}}</option>
                      </select>
                      <div class="error_text"  *ngIf="region_name.touched">
                        <p *ngIf="region_name.errors?.['required']">Region is required.</p>
                      </div>
                      </div>
                      </div>
                  </ng-container>
                </div>
              <div class="row controls">     
                <div class="col-md-12">
                  <div class="input-group-meta form-group mb-25">
                    <label>Asset Address*</label>
                    <input required type="text"  placeholder="Asset Address"  #property_address="ngModel" name="property_address"
                    name="property_address" ngModel>
                      <div class="error_text"  *ngIf="property_address.touched">
                        <p *ngIf="property_address.errors?.['required']">Asset Address is required.</p>
                      </div>
                  </div>
                </div>
              </div>

              

              <div class="col-md-6">
                <button class="theme-btn-one btn-lg"  [disabled]="!subForm.valid || isDisabled">Submit</button>
              </div>
            </div>
          </form>
        </div>
  </div>
  </div>
  